import React, { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Public, unauthenticated horizontally drifting band of recent gallery photos
 * used as the background of the login screen. Falls back to a static
 * gradient if no images yet exist or if the request fails.
 */
export default function LoginBackdrop() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    let active = true;
    axios
      .get(`${API}/public/login_backdrop`, { params: { limit: 6 } })
      .then(({ data }) => {
        if (active) setItems(data.items || []);
      })
      .catch((e) => {
        console.error("login backdrop fetch failed", e);
      });
    return () => {
      active = false;
    };
  }, []);

  if (items.length === 0) {
    return (
      <div
        className="absolute inset-0 z-0"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1498510531355-5dc32e16bf47?crop=entropy&cs=srgb&fm=jpg&q=85')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          filter: "brightness(0.25) blur(2px)",
        }}
      />
    );
  }

  const duplicated = [...items, ...items];
  const duration = `${Math.max(50, items.length * 12)}s`;

  return (
    <div data-testid="login-backdrop" aria-hidden className="absolute inset-0 z-0 overflow-hidden">
      <div
        className="flex gap-6 marquee-left h-full"
        style={{
          width: "max-content",
          animationDuration: duration,
          filter: "brightness(0.55) saturate(1.1)",
        }}
      >
        {duplicated.map((img, i) => (
          <img
            key={`bd-${i}`}
            src={img.data_url}
            alt=""
            className="h-screen w-[420px] object-cover"
            loading="lazy"
            decoding="async"
          />
        ))}
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-[#0F0407]/55 via-[#0F0407]/40 to-[#0F0407]/85 backdrop-blur-[2px]" />
    </div>
  );
}
